import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MULTIPLIER_VS_DISTAN;

import _stubTrue from 'lodash/stubTrue';
export var ES_REFETCH_DELAY = 1200;
export var EMPTY_PLACEHOLDER_IMAGE_URL = 'https://dms-tst.s3-us-west-1.amazonaws.com/public-images/Empty+State.png';
export var OS_TYPES = {
  WINDOWS: 1,
  MAC_OS: 2,
  LINUX: 3,
  UNIX: 4
};
export var BUILD_ENVS = {
  preprod: 'preprod',
  prod: 'prod',
  tst: 'tst',
  dev: 'dev',
  local: 'local'
};
export var DEFAULT_KEY_FOR_GLOBAL_TEKION_DATA = 'tekion';
export var DISTANCE_FORMAT_TYPE = {
  KMS: 'KMS',
  // need to be deprecated as it should match with mileageMeasure from dealerMaster
  MILES: 'MILES',
  KM: 'KM'
};
export var MULTIPLIER_VS_DISTANCE_FORMAT = (_MULTIPLIER_VS_DISTAN = {}, _defineProperty(_MULTIPLIER_VS_DISTAN, DISTANCE_FORMAT_TYPE.MILES, 0.621371), _defineProperty(_MULTIPLIER_VS_DISTAN, DISTANCE_FORMAT_TYPE.KMS, 1.60934), _defineProperty(_MULTIPLIER_VS_DISTAN, DISTANCE_FORMAT_TYPE.KM, 1.60934), _MULTIPLIER_VS_DISTAN);
export var EQUALITY_VS_COMPARATOR = {
  LESS_THAN: function LESS_THAN(baseValue, valueToCompare) {
    return valueToCompare < baseValue;
  },
  LESS_THAN_OR_EQUALS: function LESS_THAN_OR_EQUALS(baseValue, valueToCompare) {
    return valueToCompare <= baseValue;
  },
  GREATER_THAN: function GREATER_THAN(baseValue, valueToCompare) {
    return valueToCompare > baseValue;
  },
  GREATER_THAN_OR_EQUALS: function GREATER_THAN_OR_EQUALS(baseValue, valueToCompare) {
    return valueToCompare >= baseValue;
  },
  EQUALS: function EQUALS(baseValue, valueToCompare) {
    return baseValue === valueToCompare;
  },
  DEFAULT: _stubTrue
}; // <-------------- Display scale constants -------------->

export var DISPLAY_SIZES = {
  // in px (absolute viewport size)
  M: 1194,
  S: 1024,
  XS: 834
};
export var DISPLAY_SCALES = {
  // in % (percentage font-size)
  MAXIMUM: 100.0,
  L: 62.5,
  M: 42.5,
  S: 37.5,
  XS: 32.5,
  MINIMUM: 10.0
};
export var SCALE_TYPES = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};
export var DEFAULT_DISPLAY_SCALE = DISPLAY_SCALES.L;
export var DEFAULT_SCALE_TYPE = SCALE_TYPES.AUTOMATIC;
export var PROBE_DIV_ELEMENT_HEIGHT = 64; // in px (defined 6.4rem in index.html)

export var PROBE_DIV_ELEMENT_ID = 'probe-div-element';